import { gql } from "@grandvisionhq/graphql";
import { returnsLineItemsFragment } from "./line-item.js";
const returnInfoFragment = gql`
  fragment ReturnInfoFragment on SlimOrderReturnInfo {
    items {
      comment
      quantity
      lineItem {
        ...ReturnsLineItemsFragment
      }
    }
    returnDate
    returnTrackingId
  }
  ${returnsLineItemsFragment}
`;
export {
  returnInfoFragment
};
//# sourceMappingURL=return-info.js.map
